import React from 'react';
import { MujerSoberanaHub } from '../../../components/MujerSoberana';
import { useNavigate } from 'react-router-dom';
import VerticalNavBar from '../../../components/Navbar/PlatformNavBar/VerticalNavBar';

/**
 * Mujer Soberana Platform Page
 * Integrates the sanctuary hub into the main platform
 */
const MujerSoberanaPage: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigation = (section: string) => {
    // Handle navigation events from the hub
    if (section.startsWith('subscribe:')) {
      const planId = section.split(':')[1];
      // Navigate to subscription page or handle payment
      navigate('/subscripciones');
    } else if (section.startsWith('tag:')) {
      // Handle tag filtering
      console.log('Filter by tag:', section);
    }
  };

  return (
    <section className="index-platform relative flex gap-3 overflow-x-hidden min-h-screen">
        <VerticalNavBar />
        <div className="mujer-soberana-page h-[100vh] md:h-auto w-full md:w-[85%] overflow-y-auto">
            <MujerSoberanaHub 
                enableAnimations={true}
                onNavigate={handleNavigation}
            />
        </div>
    </section>
  );
};

export default MujerSoberanaPage;
